import { I18n } from 'react-redux-i18n';

class Тranslator {
	translate(key) {
		if (!key) return "";
		const translation = I18n.t(key);
		return translation || key;
	}
}

const translator =  new Тranslator();

export default translator;